var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6222 11.3175H13.9547C14.3544 11.3175 14.6209 11.051 14.6209 10.6513V8.65262C14.6209 8.05302 14.1545 7.52004 13.6215 7.3868C12.4223 7.05368 10.6235 6.65395 10.6235 6.65395C10.6235 6.65395 9.75744 5.72123 9.15784 5.12163C8.82473 4.85514 8.42499 4.65527 7.95864 4.65527H3.29506C2.89533 4.65527 2.56221 4.92176 2.36235 5.25488L1.42963 7.18693C1.34141 7.44424 1.29639 7.71438 1.29639 7.9864V10.6513C1.29639 11.051 1.56288 11.3175 1.96261 11.3175H3.29506",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62737 12.6503C5.36326 12.6503 5.95982 12.0537 5.95982 11.3178C5.95982 10.5819 5.36326 9.98535 4.62737 9.98535C3.89148 9.98535 3.29492 10.5819 3.29492 11.3178C3.29492 12.0537 3.89148 12.6503 4.62737 12.6503Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95996 11.3174H9.95731",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2897 12.6503C12.0256 12.6503 12.6222 12.0537 12.6222 11.3178C12.6222 10.5819 12.0256 9.98535 11.2897 9.98535C10.5538 9.98535 9.95728 10.5819 9.95728 11.3178C9.95728 12.0537 10.5538 12.6503 11.2897 12.6503Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.c4e0fb3ee59882b18f8e76b098ea3982.svg";
export { ForwardRef as ReactComponent };